import './polyfills';

import React from 'react';
import ReactDOM from 'react-dom';
import * as appLifecycleService from './services/app-lifecycle-service';

function runMyApp() {
  appLifecycleService.appLoaded();
  const renderFn = ReactDOM.hydrate || ReactDOM.render;
  const Deprecation = () => <div></div>;
  renderFn(<Deprecation />, document.getElementById('root'));
}

runMyApp();
